import { commonIcons } from '@apps-common/config/icons'
import { useReceiversFilterStore } from '@apps-common/stores'
import classNames from 'classnames'
import { ReceiverKpiCard } from './ReceiverKpiCard'
import { ReceiverKpiCardSkeleton } from './ReceiverKpiCardSkeleton'
import { receiverParams } from './receiver-constants'

interface IProps {
  loading: boolean
  className?: string
}

export const ReceiverKpiContainer: React.FC<IProps> = ({ loading, className }) => {
  const { tab, setTab, data } = useReceiversFilterStore()

  // loading = loading && !!data

  return (
    <>
      {loading && (
        <div
          className={classNames(
            className,
            !loading && 'bg-surface border border-border',
            loading && 'bg-skeleton border border-skeleton-border',
            'grid grid-cols-2 gap-[8px] min-w-[300px] lg:min-w-[320px] p-3 lg:p-4 rounded-3xl'
          )}
        >
          {Array.from(Array(6).keys()).map((k) => (
            <ReceiverKpiCardSkeleton key={`cloud-receiver-kpi-card-skeleton-${k}`} />
          ))}
        </div>
      )}
      {!loading && (
        <div
          className={classNames(
            className,
            !loading && 'bg-surface border border-border',
            loading && 'bg-skeleton border border-skeleton-border',
            'grid grid-cols-2 gap-[8px] min-w-[300px] lg:min-w-[320px] p-3 lg:p-4 rounded-3xl'
          )}
        >
          <ReceiverKpiCard
            isActive={tab === 'gateways'}
            onClick={() => setTab('gateways')}
            value={data?.gateways?.length || 0}
            text={data?.currentAzKey || '-'}
            Icon={commonIcons.receiverAz}
            color={receiverParams.find((c) => c.key === 'gateways')?.colors}
          />
          {data?.parsed?.map((p) => {
            const color = receiverParams.find((c) => c.key === p.key)

            return (
              <ReceiverKpiCard
                key={`cloud-receiver-kpi-card-${p.key}`}
                isActive={tab === p.key}
                onClick={() => setTab(p.key)}
                value={p.data?.length}
                text={p.key}
                Icon={p.Icon}
                color={color?.colors}
              />
            )
          })}
        </div>
      )}
    </>
  )
}
